<!-- <rap-breadcrumb-view-new [routerLink]="'/dashboard/explore'" [clickableLabel]="'Rap Almanac'"
    [clickableIcon]="'../assets/images/filled.svg'" [title]="title" [nonClickableLabel]="'Artists'"
    [nonClickableIcon]="'../assets/images/filled.svg'">
</rap-breadcrumb-view-new> -->
<div class="label-container">
    <div>
        <label class="clickable-label" routerLink="/dashboard/explore"> Rap Almanac </label>
        <img src="../assets/images/filled.svg" />
    </div>

    <div>
        <label class="non-clickable-label">{{title}}</label>
        <img src="../assets/images/filled.svg" />
    </div>
    <div>
        <label class="non-clickable-label" style="text-decoration: none;">Artists</label>
    </div>

</div>

<div class="section-body">
    <div class="section-title">Artists</div>
    <button type="button" class="btn btn-dark add-song-btn" (click)="createArtist()" style="margin-bottom: 20px;">
        Add New
    </button>
    <rap-spinner class="loader-overlay" *ngIf="isLoading"></rap-spinner>
</div>

<rap-search-input [(searchValue)]="filters.search" (search)="getSearchResults($event)"
    (clear)="onClearSearch()"></rap-search-input>

<div style="padding: 0px 10px;">
    <ng-container *ngIf="artistsData?.length > 0">
        <div class="custom-container">
            <div class="songs-table" *ngIf="artistsData?.length > 0">
                <table class="table rounded-4 overflow-hidden">
                    <thead>
                        <tr>
                            <!-- <th scope="col">Name</th> -->
                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'artist', direction: sortDirection })">NAME</div>
                                    <rap-sort-arrows [column]="'artist'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>
                            <!-- <th scope="col">City</th> -->
                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'origin_city', direction: sortDirection })">CITY
                                    </div>
                                    <rap-sort-arrows [column]="'origin_city'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>
                            <!-- <th scope="col">State</th> -->
                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'origin_state', direction: sortDirection })">STATE
                                    </div>
                                    <rap-sort-arrows [column]="'origin_state'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>
                            <!-- <th scope="col">Country</th> -->
                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'origin_country', direction: sortDirection })">
                                        COUNTRY
                                    </div>
                                    <rap-sort-arrows [column]="'origin_country'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>
                            <th scope="col">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let artist of paginatedArtists">
                            <td scope="row">{{ artist?.artist }}</td>
                            <td scope="row">
                                {{ artist?.city }}
                            </td>
                            <td scope="row">{{ artist?.state }}</td>
                            <td scope="row">{{ artist?.country }}</td>
                            <td>
                                <button type="button" class="btn btn-light rect-secondary-btn"
                                    (click)="editArtist(artist)">
                                    Edit
                                </button>
                                <button type="button" class="btn btn-dark rect-primary-btn"
                                    (click)="deleteArtist(artist.artistid)">
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="pagination">
                    <rap-pagination [collectionSize]="pagesCount" [page]="page" [pageSize]="pageSize"
                        (onPageChange)="onPageChange($event)"
                        (onPageSizeChange)="onPageSizeChange($event)"></rap-pagination>
                </div>
            </div>
        </div>

    </ng-container>
</div>


<rap-no-data [data]="artistsData" [isLoading]="isLoading" [filters]="filters" [message]="'No artists found'"
    [view]=""></rap-no-data>